const DilemmaFormStepSeparator = () => {
  return (
    <div className="flex lg:border-l items-start lg:items-center justify-center flex-1 border-gray-400 py-3 lg:mx-[11px]">
      <hr className="w-full lg:hidden border-gray-400" />
    </div>
  );
};

export default DilemmaFormStepSeparator;
